<template>
  <div class="promotion-detail-content">
    <mk-form
      class="form"
      label-width="90px"
    >
      <mk-form-item
        class="form-item flex-zero form-title"
        label="文章标题:"
        :rules="[{required: true}]"
      >
        <template v-if="!editStatus">
          <div>
            {{ formData.title }}
          </div>
        </template>
        <template v-else>
          <mk-input
            v-model="formData.title"
            class="form-item flex-zero"
            placeholder="请输入"
            width="320"
            maxlength="30"
            show-word-limit
          ></mk-input>
        </template>
      </mk-form-item>
      <mk-form-item
        class="form-item code flex-zero"
        label="封面图片:"
        :rules="[{required: true}]"
      >
        <template v-if="!editStatus">
          <mk-image
            :src="formData.cover"
            fit="cover"
            class="cover-img"
            alt="cover"
          />
        </template>
        <template v-else>
          <div class="upload">
            <div
              class="upload-content"
              :class="formData.cover ? 'showDelete' : ''"
            >
              <div class="delete">
                <mk-iconfont
                  class="icon"
                  icon-class="shanchu1"
                  @click.native="coverDelete"
                ></mk-iconfont>
              </div>
              <mk-upload-oss-biz
                :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
                :limit-size="2"
                accept=".jpg,.png"
                @on-upload="onImageUpload"
              >
                <div
                  v-loading="imagesLoading"
                  class="upload-cover"
                >
                  <div
                    v-if="formData.cover"
                    class="cover-div"
                  >
                    <mk-image
                      :src="formData.cover"
                      fit="cover"
                      class="cover-img"
                      alt="cover"
                    />
                  </div>
                  <mk-iconfont
                    v-else
                    icon-class="xinzeng"
                    class="plus-icon"
                  />
                </div>
              </mk-upload-oss-biz>
            </div>

            <div class="tips">
              只能上传jpg/png文件，不超过2M
            </div>
          </div>
        </template>
      </mk-form-item>
      <mk-radio-group
        v-model="meansType"
        class="select-radio flex-zero"
        size="medium"
        @change="meansChange"
      >
        <mk-radio-button label="文章内容"></mk-radio-button>
        <mk-radio-button label="二维码"></mk-radio-button>
        <mk-radio-button label="表单"></mk-radio-button>
      </mk-radio-group>
      <div
        ref="scrollContent"
        class="scroll-content"
        @scroll="scroll"
      >
        <mk-form-item
          class="form-item flex-zero"
          label="文章内容:"
          :rules="[{required: true}]"
        >
          <div
            v-if="!editStatus"
            v-html="formData.context"
          >
          </div>
          <wang-editor
            v-else
            v-model="formData.context"
            height="300px"
            placeholder="请输入内容"
          />
        </mk-form-item>
        <mk-form-item
          ref="qrCode"
          class="form-item code flex-zero"
          label="二维码:"
        >
          <div>
            <div v-if="!editStatus">
              <mk-image
                v-if="formData.qrCode"
                :src="formData.qrCode"
                fit="cover"
                class="cover-img"
                alt="cover"
              />
            </div>
            <div
              v-else
              class="upload"
            >
              <div
                class="upload-content"
                :class="formData.qrCode ? 'showDelete' : ''"
              >
                <div class="delete">
                  <mk-iconfont
                    class="icon"
                    icon-class="shanchu1"
                    @click.native="qrCodeDelete"
                  ></mk-iconfont>
                </div>
                <mk-upload-oss-biz
                  :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
                  :limit-size="2"
                  accept=".jpg,.png"
                  @on-upload="onImageUploadCode"
                >
                  <div
                    v-loading="imagesLoadingCode"
                    class="upload-cover"
                  >
                    <div
                      v-if="formData.qrCode"
                      class="cover-div"
                    >
                      <mk-image
                        :src="formData.qrCode"
                        fit="cover"
                        class="cover-img"
                        alt="cover"
                      />
                    </div>
                    <mk-iconfont
                      v-else
                      icon-class="xinzeng"
                      class="plus-icon"
                    />
                  </div>
                </mk-upload-oss-biz>
              </div>

              <div class="tips">
                只能上传jpg/png文件，不超过2M
                <br>
                *添加一个二维码在文章底部，可检测到用户的长按识别动作
              </div>
            </div>
          </div>
        </mk-form-item>
        <mk-form-item
          ref="form"
          class="form-item flex-zero form-item-form"
          label="表单:"
        >
          <div v-if="!editStatus">
            <img
              v-if="formData.formMetaCover"
              :src="formData.formMetaCover"
            >
          </div>
          <template v-else>
            <mk-button-biz @click="editForm">
              {{ formData.formMetaCover === '' ? '添加' : '编辑' }}
            </mk-button-biz>
            <div class="tips">
              *可添加一个表单在文章末尾
            </div>
            <img
              v-if="formData.formMetaCover"
              :src="formData.formMetaCover"
            >
          </template>
        </mk-form-item>
      </div>
    </mk-form>
    <div class="handle">
      <mk-button-biz
        v-if="!editStatus"
        @click="edit"
      >
        编辑
      </mk-button-biz>
      <template v-else>
        <mk-button-biz @click="cancel">
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          @click="save"
        >
          保存
        </mk-button-biz>
      </template>
    </div>
  </div>
</template>
<script>
import wangEditor from '@components/wang-editor'
import { PROMOTIONAPIS } from '../../../../../api'
const { VUE_APP_PC_B_BASE_URL, NODE_ENV } = process.env
export default {
  components: {
    wangEditor
  },
  data () {
    return {
      editStatus: false,
      formData: {
        title: '',
        cover: '',
        context: '',
        qrCode: '',
        formMeta: [],
        formMetaCover: ''
      },
      meansType: '文章内容',
      imagesLoading: false, // 文章封面图片加载
      imagesLoadingCode: false // 文章二维码图片加载
    }
  },
  created () {
    this.getBaseContent()
    this.watchStorage()
  },
  beforeDestroy () {
    localStorage.removeItem('promotionFormMeta')
    localStorage.removeItem('promotionFormMetaCover')
  },
  methods: {
    scroll (e) {
      const scrollContent = this.$refs.scrollContent
      let top = e.target.scrollTop
      let initTop = scrollContent.offsetTop
      let qrCodeTop = this.$refs.qrCode.$el.offsetTop
      let formTop = this.$refs.form.$el.offsetTop
      if (top + initTop < qrCodeTop) {
        this.meansType = '文章内容'
      } else if (top + initTop >= qrCodeTop && top + initTop < formTop) {
        this.meansType = '二维码'
      } else if (top + initTop >= formTop) {
        this.meansType = '表单'
      }
    },
    watchStorage () {
      let _this = this
      window.addEventListener(
        'storage',
        function (event) {
          if (event.key === 'promotionFormMeta') {
            let data = JSON.parse(event.newValue)
            _this.formData.formMeta = data.formMeta
          } else if (event.key === 'promotionFormMetaCover') {
            let data = JSON.parse(event.newValue)
            _this.formData.formMetaCover = data.formMetaCover
          }
        },
        true
      )
    },
    meansChange (e) {
      const scrollContent = this.$refs.scrollContent
      let initTop = scrollContent.offsetTop
      let top = initTop
      if (e === '文章内容') {
        top = initTop
      } else if (e === '二维码') {
        top = this.$refs.qrCode.$el.offsetTop
      } else {
        top = this.$refs.form.$el.offsetTop
      }
      scrollContent.scrollTop = top - initTop
    },
    goBack () {
      // 返回
      if (this.editStatus) {
        this.$confirm('内容将不会被保存', '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'none'
        }).then(() => {
          history.go(-1)
        })
      } else {
        history.go(-1)
      }
    },
    async getBaseContent () {
      const res = await PROMOTIONAPIS.ContentApi.contentDetailGet({
        _id: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        this.formData = {
          title: data.title,
          cover: data.cover,
          context: data.context,
          qrCode: data.qrCode,
          formMeta: data.formMeta,
          formMetaCover: data.formMetaCover,
          previewUrl: data.previewUrl || ''
        }
        let obj = {
          formMeta: data.formMeta || [],
          date: new Date()
        }
        localStorage.setItem('promotionFormMeta', JSON.stringify(obj))
      }
    },
    edit () {
      // 编辑
      this.editStatus = true
    },
    editForm () {
      // 添加表单
      let origin = VUE_APP_PC_B_BASE_URL
      const user = JSON.parse(window.localStorage.getItem('user'))
      let params = '?isPromotion=true'
      if (
        this.formData.formMeta instanceof Array &&
        this.formData.formMeta.length > 0
      ) {
        params += '&againEdit=true'
      }
      if (NODE_ENV === 'development') {
        origin = location.origin.replace('8087', '8089')
        const { sid, phone, id, account, accountName } = user
        params += `&sid=${sid}&phone=${phone}&id=${id}&account=${account}&accountName=${encodeURIComponent(
          accountName
        )}`
      }
      const link = `${origin}/form-editor/index.html${params}`
      window.open(link)
    },
    save () {
      if (this.verificate()) {
        // 保存
        this.editStatus = false
        this.update()
      }
    },
    verificate () {
      // 检验
      let formData = this.formData
      if (formData.title) {
        if (formData.cover) {
          if (formData.context) {
            return true
          } else {
            this.showErrorMsg('请输入文章内容')
          }
        } else {
          this.showErrorMsg('请上传文章封面图片')
        }
      } else {
        this.showErrorMsg('请输入文章标题')
      }
      return false
    },
    showErrorMsg (errorMsg) {
      this.$message({
        type: 'error',
        message: errorMsg,
        showClose: true
      })
    },
    cancel () {
      this.editStatus = false
      this.getBaseContent()
    },
    async update () {
      const res = await PROMOTIONAPIS.ContentApi.contentUpdatePost({
        _id: this.$route.query.id,
        title: this.formData.title,
        cover: this.formData.cover,
        context: this.formData.context,
        qrCode: this.formData.qrCode,
        formMeta: this.formData.formMeta,
        formMetaCover: this.formData.formMetaCover,
        previewUrl: this.formData.previewUrl
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '保存成功',
          showClose: true
        })
        this.editStatus = false
      }
    },
    onImageUpload (res) {
      // 文章封面图片上传
      if (res.type === 'success') {
        this.imagesLoading = false
        this.uploadSuccess(res)
      } else if (res.type === 'fail') {
        this.imagesLoading = false
      } else if (['before', 'progress'].includes(res.type)) {
        this.imagesLoading = true
      }
    },
    onImageUploadCode (res) {
      // 文章二维码图片上传
      if (res.type === 'success') {
        this.imagesLoadingCode = false
        this.uploadSuccessCode(res)
      } else if (res.type === 'fail') {
        this.imagesLoadingCode = false
      } else if (['before', 'progress'].includes(res.type)) {
        this.imagesLoadingCode = true
      }
    },
    coverDelete () {
      this.formData.cover = ''
    },
    qrCodeDelete () {
      this.formData.qrCode = ''
    },
    uploadSuccess (res) {
      // 成功上传
      this.formData.cover = res.result.url
    },
    uploadSuccessCode (res) {
      // 成功上传
      this.formData.qrCode = res.result.url
    }
  }
}
</script>
<style lang="scss" scoped>
.promotion-detail-content {
  display: flex;
  flex-direction: column;
  height: 100%;

  .form-title {
    /deep/ .el-input__inner {
      padding-right: 44px;
    }
  }

  /deep/ .w-e-menu {
    z-index: 2000 !important;
  }

  /deep/ .w-e-text-container {
    z-index: 1999 !important;
  }

  /deep/ .upload-cover {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    box-sizing: border-box;
    background-color: #fafafa;
    border-radius: 4px;
    border: 1px dashed #d4d4d4;

    .cover-div {
      position: relative;
      width: 60px;
      height: 60px;

      .cover-img {
        width: 100%;
        height: 100%;
      }

      .icon {
        display: none;
      }
    }

    .plus-icon {
      font-size: 27px;
    }
  }

  .form {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    margin-top: 32px;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    min-height: 500px;

    .form-item {
      width: calc(100% - 88px);
      margin: 0 auto;

      .cover-img {
        display: block;
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }
    }

    .code {
      margin-top: 16px;
    }

    .select-radio {
      width: calc(100% - 72px);
      margin: 24px 0;
      margin-left: 36px;
    }
  }

  .handle {
    display: flex;
    height: 56px;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .upload {
    .upload-content {
      width: 60px;
      height: 60px;
      position: relative;

      .delete {
        position: absolute;
        width: 60px;
        height: 60px;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.5);
        display: none;

        .icon {
          font-size: 18px;
          color: #fafafa;
          cursor: pointer;
        }
      }
    }

    .showDelete:hover {
      .delete {
        display: block;
        display: flex;
        align-items: center;
        justify-content: space-around;
        z-index: 99;
      }
    }

    .tips {
      color: #8c8c8c;
      font-size: 12px;
      line-height: 24px;
      margin-top: 8px;
    }
  }

  .form-item-form {
    .tips {
      color: #8c8c8c;
      font-size: 12px;
      line-height: 24px;
      margin-top: 0;
    }
  }

  .flex-zero {
    flex-shrink: 0;
  }

  .scroll-content {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 24px;
  }
}
</style>
